module.exports = __webpack_public_path__ + "img/451031.891bdf8d.png";